import React from 'react'

export default function BuyNearby({propertyNearby ,exploreNearBy}) {
  return (
    <>
    {/* if any nearby added then only show this otherwise hide it  */}
              {propertyNearby?.length > 0 ? (
                <div className="property-explore-nearby property-details-block">
                  <div className="row">
                    <div className="col-12">
                      <div className="property-explore-nearby-content">
                        <h3>Explore Nearby</h3>
                        <div className="nearby-content-container">
                          <div className="row">

                            {/* //business centers */}
                            {propertyNearby.filter(
                              (nearby) =>
                                nearby.nearTypeName ===
                                exploreNearBy.BusinessCentres
                            ).length > 0 && (
                              <div className="col-4 width-50">
                                <div className="nearby-content-box">
                                  <p>Business</p>
                                  <ul className="nearby-list">
                                    {propertyNearby
                                      .filter(
                                        (nearby) =>
                                          nearby.nearTypeName ===
                                          exploreNearBy.BusinessCentres
                                      )
                                      .map((item, index) => (
                                        <li key={index}>
                                          {item.nearByName}
                                          <span>{item.distanceInKM} KM</span>
                                        </li>
                                      ))}
                             
                                  </ul>
                                </div>
                              </div>
                            )}
                           
                           {/* Shopping Centers */}

                             {propertyNearby.filter(
                              (nearby) =>
                                nearby.nearTypeName ===
                                exploreNearBy.Shopping
                            ).length > 0 && (
                              <div className="col-4 width-50">
                                <div className="nearby-content-box">
                                  <p>Shopping</p>
                                  <ul className="nearby-list">
                                    {propertyNearby
                                      .filter(
                                        (nearby) =>
                                          nearby.nearTypeName ===
                                          exploreNearBy.Shopping
                                      )
                                      .map((item, index) => (
                                        <li key={index}>
                                          {item.nearByName}
                                          <span>{item.distanceInKM} KM</span>
                                        </li>
                                      ))}
                             
                                  </ul>
                                </div>
                              </div>
                            )}


                            {/* Temples  */}
                              {propertyNearby.filter(
                              (nearby) =>
                                nearby.nearTypeName ===
                                exploreNearBy.Temples
                            ).length > 0 && (
                              <div className="col-4 width-50">
                                <div className="nearby-content-box">
                                  <p>Temples</p>
                                  <ul className="nearby-list">
                                    {propertyNearby
                                      .filter(
                                        (nearby) =>
                                          nearby.nearTypeName ===
                                          exploreNearBy.Temples
                                      )
                                      .map((item, index) => (
                                        <li key={index}>
                                          {item.nearByName}
                                          <span>{item.distanceInKM} KM</span>
                                        </li>
                                      ))}
                             
                                  </ul>
                                </div>
                              </div>
                            )}

                            {/* Hospitals */}
                              {propertyNearby.filter(
                              (nearby) =>
                                nearby.nearTypeName ===
                                exploreNearBy.Hospitals
                            ).length > 0 && (
                              <div className="col-4 width-50">
                                <div className="nearby-content-box">
                                  <p>Hospitals</p>
                                  <ul className="nearby-list">
                                    {propertyNearby
                                      .filter(
                                        (nearby) =>
                                          nearby.nearTypeName ===
                                          exploreNearBy.Hospitals
                                      )
                                      .map((item, index) => (
                                        <li key={index}>
                                          {item.nearByName}
                                          <span>{item.distanceInKM} KM</span>
                                        </li>
                                      ))}
                             
                                  </ul>
                                </div>
                              </div>
                            )}

                            {/* Eatouts */}
                              {propertyNearby.filter(
                              (nearby) =>
                                nearby.nearTypeName ===
                                exploreNearBy.Eatouts
                            ).length > 0 && (
                              <div className="col-4 width-50">
                                <div className="nearby-content-box">
                                  <p>EatOuts</p>
                                  <ul className="nearby-list">
                                    {propertyNearby
                                      .filter(
                                        (nearby) =>
                                          nearby.nearTypeName ===
                                          exploreNearBy.Eatouts
                                      )
                                      .map((item, index) => (
                                        <li key={index}>
                                          {item.nearByName}
                                          <span>{item.distanceInKM} KM</span>
                                        </li>
                                      ))}
                             
                                  </ul>
                                </div>
                              </div>
                            )}
                            {/* Nearest Properties */}
                              {propertyNearby.filter(
                              (nearby) =>
                                nearby.nearTypeName ===
                                exploreNearBy.NearestProperties
                            ).length > 0 && (
                              <div className="col-4 width-50">
                                <div className="nearby-content-box">
                                  <p>Nearest Properties</p>
                                  <ul className="nearby-list">
                                    {propertyNearby
                                      .filter(
                                        (nearby) =>
                                          nearby.nearTypeName ===
                                          exploreNearBy.NearestProperties
                                      )
                                      .map((item, index) => (
                                        <li key={index}>
                                          {item.nearByName}
                                          <span>{item.distanceInKM} KM</span>
                                        </li>
                                      ))}
                             
                                  </ul>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
    </>
  )
}



